export default __webpack_public_path__ + "static/media/CapaLogoBeta.3a01918f.svg";